export default {
      id: "rapnet-red-usage",
      viewBox: "0 0 200 36",
      url: __webpack_public_path__ + "icons.svg#rapnet-red",
      toString: function () {
        return this.url;
      }
    }